import { IActionProps } from 'types'

export default (actionType: string) => (args?: IActionProps) => ({
  type: actionType,
  ...args,
})
